import { Component, Renderer2, ViewEncapsulation } from '@angular/core';
import { SessionService } from '@app/shared/helpers';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { GlobalStateService } from '@app/shared/states';
import { DatadogMonitoringService } from '@app/core/services';
import { TokenService } from '@app/shared/services/token.service';

const LIGHT_CES_LOGO: string = '/assets/images/CES-logo-svg-dark.svg';
const DARK_CES_LOGO: string = '/assets/images/CES-logo-svg.svg';
@Component({
  selector: 'app-acounts',
  templateUrl: './acounts.component.html',
  styleUrls: ['./acounts.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class AcountsComponent {
  destroy$: Subject<boolean> = new Subject<boolean>();
  userName: string = '';
  avatarName: string = '';
  switchThemeToggle: boolean = false;
  showAdminBtn: boolean = false;
  profileUserMenu: any = [
    {
      iconClass: 'icon-user',
      label: 'Profile',
      link: '/account/profile',
    },
    {
      iconClass: 'icon-logout',
      label: 'Log out',
      link: '/logout',
    },
  ];
  profileUrl: string;
  isExpand: boolean = false;
  headerLogo: any = LIGHT_CES_LOGO;
  showAppsBtn: boolean = false;
  isAdmin: boolean = false;
  constructor(
    private render: Renderer2,
    private auth0Service: Auth0Service,
    private sessionService: SessionService,
    private router: Router,
    private globalState: GlobalStateService,
    private datadog: DatadogMonitoringService,
    private tokenService: TokenService
  ) {
    this.checkPreviousTheme();
    this.setUserName();
    this.appsBtnAction(this.router.url);
  }
  ngOnInit(): void {
    if (this.tokenService.checkSuperAdmin()) {
      this.addMfaMenu();
    }

    if (!this.globalState.getDatadogState()) {
      this.datadog.setDataDogRum();
    }
    this.globalState.isAdminAccessEvent.subscribe((response) => {
      this.isAdmin = response;
      this.showAdminBtn = response;
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.appsBtnAction(event.url);
      }
    });
  }

  /**
   * Add mfa menu
   */
  addMfaMenu() {
    let isMFAMenu: any = this.profileUserMenu.find((item) => item.label == '2 Factor Auth');
    if (!isMFAMenu) {
      this.profileUserMenu.splice(1, 0, {
        iconClass: 'icon-settings',
        label: '2 Factor Auth',
        link: '/account/security',
      });
    }
  }

  /**
   * show apps button based on route
   */
  appsBtnAction(url) {
    if (url === '/account/apps') {
      this.showAppsBtn = false;
      if (this.isAdmin) {
        this.showAdminBtn = true;
      }
    } else {
      this.showAppsBtn = true;
      this.showAdminBtn = false;
    }
  }

  /* Angular destroy fn */
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
  /**
   * Check previous theme and apply it
   */
  checkPreviousTheme() {
    let theme = this.sessionService.getTheme() ?? this.render['engine'].bodyNode.className;
    if (theme) {
      this.switchThemeToggle = theme == 'dark-theme' ? true : false;
      this.setTheme(theme);
    }
  }

  /**
   * Apply theme
   */
  setTheme(theme) {
    if (theme == 'dark-theme') {
      this.headerLogo = DARK_CES_LOGO;
    } else {
      this.headerLogo = LIGHT_CES_LOGO;
    }
    this.render['engine'].bodyNode.className = theme;
    this.sessionService.setTheme(theme);
  }

  /**
   * Set username to profile icon
   */
  setUserName() {
    this.auth0Service.user$.pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      if (data) {
        if (data.given_name && data.family_name) {
          this.userName = `${data.given_name} ${data.family_name}`;
        } else if (data.nickname) {
          this.userName = data.nickname;
        } else {
          this.userName = data.name;
        }

        this.avatarName = this.userName
          ?.split(' ')
          .map((n) => n[0])
          .join('');
      }
    });
  }

  /**
   * Switch theme light/dark
   */
  public switchTheme() {
    this.switchThemeToggle = !this.switchThemeToggle;
    let selectedTheme = this.switchThemeToggle ? 'dark-theme' : 'light-theme';
    this.setTheme(selectedTheme);
    localStorage.setItem('theme', selectedTheme);
  }

  /**
   * Redirect to app list page
   */
  redirectApp() {
    this.router.navigate(['/account/apps']);
  }

  redirectAdmin() {
    this.router.navigate(['/auth0/admin/activity']);
  }
}
